import { ROUTES_PATHS } from '@src/constants/routes';
import { config } from '@uhg-abyss/web/tools/config';
import { Cookies } from 'react-cookie';
import { sessionStorageKeys } from '@src/CommonComponents/constant/constant';
import { APP_SESSION_KEYS } from '@src/constants/app-shell-constants';
export function fetchCurrentUser() {
  return sessionStorage.getItem('currentUser');
}
/*export function fetchPedAccessToken() {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  return currentUser[0].PedAccessToken;
}*/
export function fetchAccessToken() {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  return currentUser[0].AccessToken;
}
export function checkIsInternal() {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  if (
    currentUser &&
    currentUser[0]?.UserPersonas &&
    currentUser[0]?.UserPersonas[0]?.UserType === 'Internal'
  ) {
    return true;
  }
  return false;
}
export function checkIsExternal() {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  if (
    currentUser &&
    currentUser[0]?.UserPersonas &&
    currentUser[0]?.UserPersonas[0]?.UserType === 'External'
  ) {
    return true;
  }
  return false;
}

export function checkOnlySimulationMode() {
  const _currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  if (sessionStorage.getItem('simulationMode') === 'true') {
    return true;
  }
  return false;
}

export const extendedTinLevelExperience = 'true'; // or 'false'
export function checkIsSimulationMode() {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  if (
    currentUser &&
    currentUser[0]?.UserPersonas &&
    currentUser[0]?.UserPersonas[0]?.UserType === 'Internal' &&
    sessionStorage.getItem('simulationMode') === 'true'
  ) {
    return true;
  }
  return false;
}

/**
 * Check if authentication is ready for API calls.
 * For external users: checks if AccessToken exists in sessionStorage
 * For internal users: checks if token exists in cookies
 */
export function isAuthReady() {
  try {
    const currentUserStr = sessionStorage.getItem('currentUser');
    if (!currentUserStr) {
      return false;
    }
    const currentUser = JSON.parse(currentUserStr);
    if (!currentUser || !Array.isArray(currentUser) || currentUser.length === 0) {
      return false;
    }
    const isInternal = currentUser[0]?.UserPersonas?.[0]?.UserType === 'Internal';
    if (isInternal) {
      // Internal users get token from cookies
      const cookies = new Cookies();
      const cookieList = Object.keys(cookies.getAll());
      const cookieToken = cookieList.find((str) => str === config('ACCESS_TOKEN'));
      return !!cookies.get(cookieToken);
    } else {
      // External users need AccessToken in sessionStorage
      return !!currentUser[0]?.AccessToken;
    }
  } catch (_e) {
    return false;
  }
}

export function fetchInternalAccessToken() {
  const cookies = new Cookies();
  const cookieList = Object.keys(cookies.getAll());
  const configKey = config('ACCESS_TOKEN');
  const cookieToken = cookieList.find((str) => str === configKey);
  if (cookies.get(cookieToken)) {
    return cookies.get(cookieToken);
  }

  // Layer 2: Fall back to sessionStorage INTERNAL_ACCESS_TOKEN (set by React authService)
  const sessionToken = sessionStorage.getItem('INTERNAL_ACCESS_TOKEN');
  if (sessionToken) {
    return sessionToken;
  }

  // Layer 3: Fall back to any cookie ending in ACCESS_TOKEN (catch-all for different env prefixes)
  const fallbackCookie = cookieList.find((str) => str.endsWith('ACCESS_TOKEN'));
  if (fallbackCookie) {
    return cookies.get(fallbackCookie);
  }

  return null;
}
export function fetchExternalAccessToken() {
  try {
    const currentUserStr = sessionStorage.getItem('currentUser');
    if (currentUserStr) {
      const currentUser = JSON.parse(currentUserStr);
      if (Array.isArray(currentUser) && currentUser.length > 0 && currentUser[0]?.AccessToken) {
        return currentUser[0].AccessToken;
      }
    }
  } catch (_e) {
    // Ignore parse errors
  }

  const sessionToken = sessionStorage.getItem('accessToken');
  if (sessionToken) {
    return sessionToken;
  }

  const cookies = new Cookies();
  const cookieList = Object.keys(cookies.getAll());
  const cookieToken = cookieList.find((str) => str.endsWith('ACCESS_TOKEN'));
  if (cookieToken) {
    return cookies.get(cookieToken);
  }

  return null;
}

export function checkSingleTin() {
  return (
    sessionStorage.getItem('multiTinNavigation') &&
    sessionStorage.getItem('multiSelectedTins').split(',').length === 1
  );
}
export function checkMultiTin() {
  return (
    sessionStorage.getItem('multiTinNavigation') &&
    sessionStorage.getItem('multiSelectedTins').split(',').length > 1
  );
}
export function checkGeoFlow() {
  return sessionStorage.getItem('GeoCriteria') !== 'null';
}
export function getGeoCriteria() {
  const geoCriteria = sessionStorage.getItem('GeoCriteria');
  return geoCriteria && geoCriteria !== 'null' ? geoCriteria : null;
}
export function checkHCO() {
  return !sessionStorage.getItem('multiTinNavigation');
}
export function getLoggedUser() {
  if (sessionStorage.getItem('loggedUser')) {
    return sessionStorage.getItem('loggedUser');
  }
  return null;
}

const parseSessionJson = (key, fallback) => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

const hasEmulatedUuid = () => {
  const emulatedUuid = sessionStorage.getItem('emulatedUuid');
  return Boolean(emulatedUuid && emulatedUuid !== 'null' && emulatedUuid !== '""');
};

export function getDisplayUser() {
  const loggedUser = parseSessionJson('loggedUser', {});
  const currentUser = parseSessionJson('currentUser', []);
  const isExternal = currentUser?.[0]?.UserPersonas?.[0]?.UserType === 'External';
  const emulatedUser = loggedUser?.EmulatedUserDetails;
  const hasEmulatedName =
    (typeof emulatedUser?.FirstName === 'string' && emulatedUser.FirstName.trim()) ||
    (typeof emulatedUser?.LastName === 'string' && emulatedUser.LastName.trim());
  const isExternalEmulation = isExternal && hasEmulatedUuid() && Boolean(hasEmulatedName);

  if (isExternalEmulation) {
    return {
      user: {
        ...loggedUser,
        FirstName: emulatedUser.FirstName.trim(),
        LastName: emulatedUser.LastName.trim(),
        EmailId: typeof emulatedUser.EmailId === 'string' ? emulatedUser.EmailId.trim() : '',
      },
      isExternalEmulation: true,
    };
  }

  return { user: loggedUser, isExternalEmulation: false };
}

export const getMultiTins = () => {
  if (checkMultiTin()) {
    return sessionStorage.getItem('multiSelectedTins');
  } else {
    return '';
  }
};

export const getMultiTinsWithTinName = () => {
  if (checkMultiTin()) {
    return sessionStorage.getItem('multiSelectedTinsGC');
  } else {
    return '';
  }
};

export const isMultiTinVal = () => {
  if (sessionStorage.getItem('multiTinNavigation')) {
    return true;
  } else {
    return false;
  }
};

export const checkBulkFlow = () => {
  return sessionStorage.getItem(sessionStorageKeys.hiVolumetTinKey) === 'true';
};

export const checkAppealsBulkFlow = () => {
  return checkBulkFlow() || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
};

export const updateGeoSegmentFilters = (state) => {
  if (state && ['REGION', 'STATES'].includes(state.key)) {
    const _value = !Array.isArray(state.value)
      ? { ...state.value, isChipDisable: !!state.value.isChipDisable }
      : state.value.map((value) => ({ ...value, isChipDisable: !!value.isChipDisable }));
    sessionStorage.setItem('GEO_SELECTED_' + state.key, JSON.stringify(_value));
  }
};
const getCorporateTin = () => {
  if (sessionStorage.getItem('mpinTinData')) {
    const tindetail = [...JSON.parse(sessionStorage.getItem('mpinTinData'))];
    if (tindetail && tindetail.length > 0) {
      return tindetail;
    } else {
      return [];
    }
  } else {
    return [];
  }
};

export const INITIAL_STATE = {
  affTaxId: [{ Tin: 'All', Tinname: 'All' }],
  vbcTaxId: [{ Tin: 'All', Tinname: 'All' }],
  exemptionTaxId: [{ Tin: 'All', Tinname: 'All' }],
  reconGlobal: {},
  Tins: getCorporateTin(),
  selectedCorporateTin: sessionStorage.getItem('currentUser')
    ? JSON.parse(sessionStorage.getItem('currentUser'))[0]['selectedTin']
    : { name: '', value: '', disable: false },
  legendGlobal: {},
  extendedCorporateTinSelected: {
    TINNAME: 'All',
    Tin: 'All Selected TINs',
    Tinname: 'All',
    isEnabled: false,
    isSelected: false,
  },
  journeyExtendedTinSelected: {
    taxId: [],
    affTaxId: [],
    priorAuthTaxId: [],
    smartEditTaxId: [],
    vbcTaxId: [],
    exemptionTaxId: [],
  },
  journeyExtendedTinFilterSelected: {
    taxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
    affTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
    priorAuthTaxId: [
      { TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false },
    ],
    smartEditTaxId: [
      { TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false },
    ],
    vbcTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
    exemptionTaxId: [
      { TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false },
    ],
  },
  hcoExtendedCorporateTinSelected: [],
  paymentClaimYeild: 'All',
  currentPage: 'overviewPage',
  currentUrl: ROUTES_PATHS.Overview.OverviewAdvocate,
  // currentComponent: OverviewComponent,
  timePeriod: 'Last12Months',
  timePeriodVBC: new Date().getFullYear().toString(),
  taxId: [{ Tin: 'All', Tinname: 'All' }],
  taxIdSmartEdit: [{ Tin: 'All', Tinname: 'All' }],
  lineOfBusiness: 'All',
  adjudicationType: 'All',
  region: 'NATIONAL',
  states: [],
  mapping: 'PROVIDER',
  edcLineOfBusiness: { order: '1', value: 'Commercial', name: 'COMMERCIAL' },
  dplineOfBusiness: 'All',
  productType: [{ ClaimProducts: ['All'], ClaimSystem: 'All', Lob: ['All'], ProductName: 'All' }],
  reconsiderationValues: 'All',
  adjustmentValues: 'All',
  commercial: 'All',
  channel: 'All',
  serviceSetting: 'All',
  providerSetting: 'Requesting Provider',
  serviceCategory: 'All',
  priorAuthType: 'All',
  trendMetric: 'Reimbursements',
  trendDate: new Date(),
  claimsFilter: 'All',
  ClaimProducts: [],
  appealsFilter: 'Received Date',
  viewClaimsByFilter: 'DOS',
  platformType: [{ name: 'All', value: 'All', check: true }],
  topFilterTimePeriod: {
    FilterText: 'All',
    StartDate: 'All',
    EndDate: 'All',
    Default: 'All',
  },
  topFilterTin: { Tin: 'All', TinName: 'All' },
  topFilterNpi: { Npi: 'All', NpiName: 'All' },
  topFilterSpeciality: { Speciality: 'All' },

  topFilterLob: { Lob: 'All' },
  priorAuthFilters: {
    timePeriod: 'Last12Months',
    timePeriodText: '',
    taxId: [{ Tin: 'All', Tinname: 'All' }],
    lineOfBusiness: 'All',
    providerSetting: 'Requesting Provider',
    channel: 'All',
    serviceSetting: 'All',
    serviceCategory: 'All',
    npi: { Value: 'All', Name: 'All' },
    specialty: { Value: 'All', Name: 'All' },
  },

  gapsInCareFilters: {
    // TimePeriod: { title: POCAGICTimePeriods[0].title, value: POCAGICTimePeriods[0].value },
    Lob: { pages: ['GAPS_IN_CARE'], title: 'All', value: 'All' },
    Tin: { Tin: 'All', Tinname: 'All' },
    Npi: { Npi: 'All', NpiName: 'All' },
  },
  PACaseSubmissionFilters: {
    //  TimePeriod: { title: POCACaseSubmissionTimePeriods[0].title, value: POCACaseSubmissionTimePeriods[0].value },
    Lob: { pages: ['PA_CASE_SUBMISSION'], title: 'All', value: 'All' },
    Tin: { Tin: 'All', Tinname: 'All' },
    Npi: { Npi: 'All', NpiName: 'All' },
  },
  glossaryOpen: false,
  tileIds: [],
  selectedPoca: {
    // timePeriod: getLocalFilters()[0],
    taxId: { Tin: 'All', Tinname: 'All' },
    lob: 'All',
    channel: 'EMR',
    npi: { Npi: 'All', NpiName: 'All' },
  },
  multiSelectData: {
    tabIndex: 0,
    groupName: '',
  },
  affordabilityPrograms: {},
  ADMFilters: { Lob: {}, State: {} },
  LOCFilters: { Lob: {}, View: {} },
  startDate: '',
  endDate: '',
  selectedState: { name: '', value: '' },
  tinsInfo: sessionStorage.getItem('state')
    ? JSON.parse(sessionStorage.getItem('state'))['tinsInfo']
    : [],
  priorAuth: {
    TaxId: { title: 'All', value: 'All' },
    Npi: { title: 'All', value: '' },
    Specialty: { title: 'All', value: '' },
    Timeperiod: 'Last12Months',
    TimeperiodText: '',
  },
};
export const getFilterState = () => {
  if (sessionStorage.getItem('state')) {
    return JSON.parse(sessionStorage.getItem('state'));
  } else {
    return null;
  }
};
export function isHighVolumeTinFlow() {
  return sessionStorage.getItem(sessionStorageKeys.hiVolumetTinKey) === 'true';
}
export function getTinGroupId() {
  return sessionStorage.getItem('tinGroupId') || '';
}

export function getUserIdFromLoggedUser() {
  if (typeof window === 'undefined') return '';
  try {
    const userStr = window.sessionStorage.getItem('loggedUser');
    if (userStr) {
      const userObj = JSON.parse(userStr);
      if (Array.isArray(userObj)) {
        return userObj[0]?.MsId || '';
      }
      return userObj?.MsId || '';
    }
  } catch (e) {
    console.warn('Failed to extract MsId from loggedUser in sessionStorage:', e);
  }
  return '';
}

export const getProviderPSMSInfo = () => {
  try {
    const providerPSMSInfo = sessionStorage.getItem('providerPSMSInfo');
    return providerPSMSInfo ? JSON.parse(providerPSMSInfo) : {};
  } catch (error) {
    console.error('Error parsing providerPSMSInfo:', error);
    return {};
  }
};

export const getPSMSProviderEntityId = () => {
  const providerInfo = getProviderPSMSInfo();
  return providerInfo?.ProviderEntityID || null;
};

export const getGroupName = () => {
  return sessionStorage.getItem('groupName') || '';
};

// Extract MsId from currentUser in sessionStorage and return as userId
export function getUserIdFromSession() {
  if (typeof window === 'undefined') return '';
  try {
    const userStr = window.sessionStorage.getItem('currentUser');
    if (userStr) {
      const userObj = JSON.parse(userStr);
      return userObj?.MsId || '';
    }
  } catch (e) {
    console.warn('Failed to extract MsId from currentUser in sessionStorage:', e);
  }
  return '';
}

export function checkContractIdFlow() {
  return sessionStorage.getItem(APP_SESSION_KEYS.CONTRACT_ID_NAVIGATION) === 'true';
}

export const isHiVolumeContractIdFlow = (storage = sessionStorage) =>
  storage.getItem(APP_SESSION_KEYS.CONTRACT_ID_NAVIGATION) === 'true' &&
  storage.getItem(APP_SESSION_KEYS.HI_VOLUME_CONTRACT_FLOW) === 'true';
